import React from 'react';

import SelectOptionArray from 'types/model/selectOption';

interface ProfileSelectProps extends React.HTMLAttributes<HTMLSelectElement> {
  defaultValue?: string;
  profiles: SelectOptionArray;
  onChange?: (event: React.ChangeEvent<HTMLSelectElement>) => void;
  disabled?: boolean;
  // Optional country id from the selected office to filter profiles by
  officeCountryId?: number | string | null;
}

function ProfileSelect({
  profiles = [],
  onChange,
  disabled,
  officeCountryId = null,
  defaultValue,
  ...rest
}: ProfileSelectProps) {
  const onChangeHandler = (event: React.ChangeEvent<HTMLSelectElement>) => {
    onChange && onChange(event);
  };
  return (
    <select
      className='select--small'
      onChange={onChangeHandler}
      disabled={disabled}
      defaultValue={defaultValue}
      {...rest}
    >
      <option value=''>{I18n.translate('traceability.select_a_profile')}</option>

      {(profiles || [])
        .filter((p: any) => {
          if (
            officeCountryId !== null &&
            officeCountryId !== undefined &&
            officeCountryId !== ''
          ) {
            const profileCountry = (p as any).country_id ?? (p as any).countryId ?? null;
            if (
              profileCountry === null ||
              String(profileCountry) !== String(officeCountryId)
            ) {
              return false;
            }
          }

          // Include active profiles. Include inactive profile only if it is the
          // currently-assigned one (so the user can change it to an active one).
          const isActive = (p as any).active !== false;
          const isCurrentlyAssigned =
            defaultValue !== undefined &&
            defaultValue !== null &&
            defaultValue !== '' &&
            String(p?.id) === String(defaultValue);

          return isActive || isCurrentlyAssigned;
        })
        .map((item: any) => {
          const id = item?.id ?? '';
          const baseName = item?.name ?? '';
          const isActive = item?.active !== false;
          const name = isActive
            ? baseName
            : `${baseName} (${I18n.translate('common.inactive')})`;

          return (
            <option key={id} value={id}>
              {name}
            </option>
          );
        })}
    </select>
  );
}

export default ProfileSelect;
